import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import Container from 'reactstrap/lib/Container';
import Row from 'reactstrap/lib/Row';
import Col from 'reactstrap/lib/Col';
import convexMask from 'site-modules/shared/components/clipped-container/mask-library/usurp-header';
import { Breadcrumbs } from 'site-modules/shared/components/breadcrumbs/breadcrumbs';
import { ClippedContainer } from 'site-modules/shared/components/clipped-container/clipped-container';

import './new-used-landing-hero.scss';

export function NewUsedLandingHero({
  breadcrumbsData = null,
  title,
  subTitle = null,
  trackingParent = null,
  children = null,
  breadcrumbsClassName = null,
  childrenClassName = 'container px-0',
  subTitleClassName = 'size-16',
  childrenColumnSizes = {
    xs: 12,
    lg: 10,
    xl: 8,
  },
}) {
  const breadcrumbs =
    breadcrumbsData &&
    breadcrumbsData.map(breadcrumb => ({
      ...breadcrumb,
      attrs: { ...breadcrumb.attrs, className: 'text-white' },
    }));
  const { xs, lg, xl } = childrenColumnSizes;

  return (
    <>
      <div className="new-used-landing-hero pos-r pb-2" data-tracking-parent={trackingParent}>
        <ClippedContainer containerClasses="new-used-landing-hero-header pos-a top-0 left-0 w-100" mask={convexMask} />

        <Container>
          {!!breadcrumbs && (
            <Breadcrumbs
              data={breadcrumbs}
              itemClassName="text-white"
              className={classnames('ps-0 text-white', breadcrumbsClassName)}
            />
          )}
          <div className="text-shadow-contrast my-1_5">
            <h1 className="heading-1 fw-bold text-white mb-0_5">{title}</h1>
            {!!subTitle && (
              <Row>
                <Col xs={12} lg={8} className={classnames('text-white', subTitleClassName)}>
                  {subTitle}
                </Col>
              </Row>
            )}
          </div>
          <Row>
            <Col xs={xs} lg={lg} xl={xl}>
              <div className={classnames('new-used-landing-hero-children', childrenClassName)}>{children}</div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

NewUsedLandingHero.propTypes = {
  title: PropTypes.string.isRequired,
  subTitle: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  breadcrumbsData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
      dataTrackingId: PropTypes.string,
    })
  ),
  trackingParent: PropTypes.string,
  children: PropTypes.node,
  breadcrumbsClassName: PropTypes.string,
  childrenClassName: PropTypes.string,
  subTitleClassName: PropTypes.string,
  childrenColumnSizes: PropTypes.shape({
    xs: PropTypes.number,
    lg: PropTypes.number,
    xl: PropTypes.number,
  }),
};
